import { Grid } from '@mui/material';
import { ChangePassword } from 'components/ChangePassword';
import { useChangePasswordMutation } from 'redux/api/authApi';
import { IUserLoggedState } from 'redux/features/loggedUserSlice';
import { useAppSelector } from 'redux/store';

/**
 * Component to render password changing
 */

const ChangePasswordPage = () => {
  
  const { user } = useAppSelector( (state: { userLoggedState: IUserLoggedState }) => state.userLoggedState);

  const [changePassword, { error: apiError, isSuccess, isLoading }] = useChangePasswordMutation();

  const onChangePasswordHandler = (password: string, currentPassword: string) => {
    changePassword({ currentPassword, password, userId: String(user?.id) });
  };

  // If password is changed, success view is rendered

  if (isSuccess) {
    return <ChangePassword.ChangePasswordSuccess />;
  };

  return (
    <Grid container spacing={2}
      sx={{ paddingTop: '2rem' }}
      alignItems="center"
      justifyContent="center">

      <Grid item xs={12} sm={8} lg={4} >
        <ChangePassword.Form onSubmit={onChangePasswordHandler} apiError={apiError} isLoading={isLoading} />
      </Grid>
    </Grid>
  );
};

export default ChangePasswordPage;
